import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    // Live Routes
    //-------------
    { // Dashboard Routes
      path: '/',
      component: () => import('@/views/dashboard/Index'),
      children: [
        {
          name: 'File Upload',
          path: '',
          component: () => import('@/views/dashboard/live/FileManage/FileUpload'),
        },
        {
          name: 'Files',
          path: 'files',
          component: () => import('@/views/dashboard/live/FileManage/FileList'),
        },
        {
          name: 'User Management',
          path: '/users',
          component: () => import('@/views/dashboard/live/UserManage/Index'),
        }
      ],
      meta: {
        auth: {
          roles: 'admin', redirect: '/auth/login', forbiddenRedirect: '/403',
        },
      },
    },
    { // Auth Routes
      name: 'User Management',
      path: '/auth',
      component: () => import('@/views/pages/Index'),
      children: [
        {
          name: 'Login',
          path: '/auth/login',
          component: () => import('@/views/pages/Login'),
        }
      ]
    },
    {
      path: '*',
      component: () => import('@/views/pages/Index'),
      children: [
        {
          name: '404 Error',
          path: '',
          component: () => import('@/views/pages/Error'),
        },
      ],
    },
  ],
})
